// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef61d95c","455":"3e0e2241","977":"1055f21a"}[chunkId] + ".chunk.js";
};